module.exports = __webpack_public_path__ + "static/img/indexbg4.786d1b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg4.jpg
// module id = KLG8
// module chunks = 1